import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { AdminManagerService } from "../services/admin-manager.service";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
import { DwConfigService, DwConfigServiceToken, getParameterByName } from "@devwareapps/devware-cap";
import { tap } from "rxjs/operators";

@Injectable()
export class SchoolOverrideHttpInterceptor implements HttpInterceptor {


    constructor(private adminManagerService: AdminManagerService, private router: Router,
        @Inject(DwConfigServiceToken) private configService: DwConfigService,
    ) {

    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const headers: { [prop: string]: string } = {};

        if (this.adminManagerService.canChangeFlightSchool()) {

            // Only apply to requests that are going to the API
            if (request.url.indexOf(this.configService.coreConfig.apiRoot) == -1) {
                return next.handle(request);
            }
            
            const aviatorUser = this.adminManagerService.getAviatorUser();

            if (aviatorUser.FlightSchoolId) {
                headers['AVIATOR-SCHOOL-ID-OVERRIDE'] = aviatorUser.FlightSchoolId.toString();
            }
        }

        request = request.clone({
            headers: request.headers,
            setHeaders: headers
        })

        return next.handle(request);
    }
}